import PageHeader from "@/components/PageHeader";
import EmailsTab from "@/components/EmailsTab";
import ExternalRepliesPanel from "@/components/mail/ExternalRepliesPanel";
import { useSearchParams } from "react-router-dom";

export default function Inbox() {
  const [sp] = useSearchParams();
  const entityType = sp.get("entity_type");
  const entityId = sp.get("entity_id");
  return (
    <div className="space-y-4" data-testid="inbox-page">
      <PageHeader
        eyebrow="Communications"
        title={entityType && entityId ? `Inbox — ${entityType}` : "Inbox"}
        subtitle="Every email sent through Acquilix, plus replies polled from connected Gmail accounts. Attach threads to clients, brands, projects, invoices or leads to keep context in one place."
      />
      <EmailsTab entityType={entityType || undefined} entityId={entityId || undefined} />
      {/* R47 · Phase 2 — inbound replies captured via workspace IMAP */}
      <ExternalRepliesPanel entityType={entityType || undefined} entityId={entityId || undefined} />
    </div>
  );
}
